const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-116"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,280.83A5.82,5.82,0,1,1,261,275,5.83,5.83,0,0,1,255.2,280.83Zm0-8.64A2.82,2.82,0,1,0,258,275,2.83,2.83,0,0,0,255.2,272.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.12,
    y: 276.7,
    width: 3,
    height: 9.75,
    transform: "translate(-122.47 267.22) rotate(-44.96)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.02,
    cy: 104.08,
    r: 29.98,
    transform: "translate(246.64 498.06) rotate(-80.78)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,134.73a30.66,30.66,0,0,1,0-61.31v1.35a29.31,29.31,0,0,0,0,58.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,134.73v-1.35a29.31,29.31,0,1,0,0-58.61V73.42a30.66,30.66,0,1,1,0,61.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.77,104.08h-1.35c0-9.93-5-23.23-14.68-29.41l.73-1.14C426.51,80,431.77,93.78,431.77,104.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.47,133.72l-.73-1.14c9.64-6.18,14.68-19.48,14.68-29.41h1.35C431.77,113.47,426.51,127.27,416.47,133.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.79,104.08h-1.35c0-10.31,5.25-24.11,15.3-30.55l.73,1.13C406.83,80.85,401.79,94.14,401.79,104.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.74,133.71c-10.05-6.45-15.3-20.25-15.3-30.55h1.35c0,9.94,5,23.23,14.68,29.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.43,
    y: 74.09,
    width: 1.35,
    height: 59.96,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.73,
    y: 87.43,
    width: 50.76,
    height: 1.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.14,
    y: 103.91,
    width: 59.94,
    height: 1.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.4,
    y: 120.38,
    width: 49.41,
    height: 1.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.59,93a20.16,20.16,0,0,0-.88-6l5.23-4.59-3.29-5.7L90.06,79a20.55,20.55,0,0,0-10.31-6l-1.37-6.81H71.81L70.45,73a20.58,20.58,0,0,0-10.32,6l-6.59-2.23-3.28,5.7,5.22,4.59a20.59,20.59,0,0,0,0,11.91l-5.22,4.58,3.28,5.7L60.13,107a20.58,20.58,0,0,0,10.32,6l1.36,6.82h6.57L79.75,113a20.55,20.55,0,0,0,10.31-6l6.59,2.23,3.29-5.7L94.71,99A20.27,20.27,0,0,0,95.59,93ZM75.1,104.08A10.66,10.66,0,1,1,85.75,93.42,10.65,10.65,0,0,1,75.1,104.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79,121.34a15.76,15.76,0,0,0-.67-4.53l4-3.5-2.5-4.33-5,1.7a15.58,15.58,0,0,0-7.85-4.54l-1-5.19h-5l-1,5.19a15.61,15.61,0,0,0-7.86,4.54l-5-1.7-2.51,4.33,4,3.5a15.68,15.68,0,0,0,0,9.07l-4,3.49,2.51,4.34,5-1.7a15.61,15.61,0,0,0,7.86,4.54l1,5.19h5l1-5.19a15.58,15.58,0,0,0,7.85-4.54l5,1.7,2.5-4.34-4-3.49A15.83,15.83,0,0,0,123.79,121.34Zm-15.61,8.43a8.12,8.12,0,1,1,8.11-8.11A8.11,8.11,0,0,1,108.18,129.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.61 95.56 201.26 90.17 203.92 95.55 209.86 96.41 205.56 100.6 206.58 106.51 201.27 103.72 195.97 106.52 196.98 100.61 192.68 96.42 198.61 95.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.78 95.56 225.43 90.17 228.09 95.55 234.02 96.41 229.73 100.6 230.75 106.51 225.44 103.72 220.13 106.52 221.14 100.61 216.84 96.42 222.78 95.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.94 95.56 249.59 90.17 252.25 95.55 258.19 96.41 253.9 100.6 254.92 106.51 249.61 103.72 244.3 106.52 245.31 100.61 241.01 96.42 246.94 95.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.11 95.56 273.76 90.17 276.42 95.55 282.36 96.41 278.06 100.6 279.08 106.51 273.77 103.72 268.47 106.52 269.48 100.61 265.18 96.42 271.11 95.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.28 95.56 297.93 90.17 300.59 95.55 306.52 96.41 302.23 100.6 303.25 106.51 297.94 103.72 292.63 106.52 293.64 100.61 289.34 96.42 295.28 95.56",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-116"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-116",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.66,402.43l-.2,2.3a2.34,2.34,0,0,0,.09.84h0a1.46,1.46,0,0,0,.16.36,3.33,3.33,0,0,0,.24.32,1.59,1.59,0,0,0,.3.27,2,2,0,0,0,1.16.37h82.4a1.9,1.9,0,0,0,.58-.09,2.5,2.5,0,0,0,.38-.15,2.18,2.18,0,0,0,1-1,2.08,2.08,0,0,0,.23-.78l.19-2.21a1.7,1.7,0,0,0-.09-.78,1.66,1.66,0,0,0-.15-.33,1.76,1.76,0,0,0-.64-.63,2.72,2.72,0,0,0-.35-.16,1.84,1.84,0,0,0-.57-.09H243.87a3.8,3.8,0,0,1-.77-.07h0l-.29-.08a.05.05,0,0,1,0,0h0a2.08,2.08,0,0,1-.32-.12,1,1,0,0,1-.28-.14,2.85,2.85,0,0,1-.41-.26,3.32,3.32,0,0,1-.43-.41c-.07-.09-.14-.17-.21-.27l-.14-.2-.05-.08v0a1.59,1.59,0,0,1-.15-.29l-.12-.27a.14.14,0,0,0,0-.06.14.14,0,0,0,0-.07s0,0,0,0a1.05,1.05,0,0,1-.06-.24,1.86,1.86,0,0,1,0-.34,0,0,0,0,1,0,0c0-.1,0-.21,0-.32s0-.21,0-.32V397a3.11,3.11,0,0,1,0-.32c0-.12.05-.22.07-.33h0l8.06-30.92,1.55-5.94,1.21-4.65h-46.8l-2.51,4.65-3.2,5.94-18.2,33.74c-.06.12-.12.24-.19.36a0,0,0,0,1,0,0l-.18.41c-.05.14-.11.27-.16.42l-.09.28A8.46,8.46,0,0,0,179.66,402.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16,402.68l-.19,2.23a2.21,2.21,0,0,1-2.16,2H181.43a2,2,0,0,1-2-2.16l.2-2.3a8.29,8.29,0,0,1,.36-1.81,9.29,9.29,0,0,1,.64-1.49l23.92-44.33h46.8l-10.82,41.51a3.21,3.21,0,0,0-.13.73,3.37,3.37,0,0,0,2.67,3.58,3.14,3.14,0,0,0,.77.08h20.49A1.79,1.79,0,0,1,266.16,402.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,399.13l23.91-44.34h2.65l-23.92,44.34a8.53,8.53,0,0,0-1,3.3l-.2,2.3a1.94,1.94,0,0,0,2,2.15h-2.65a1.94,1.94,0,0,1-2-2.15l.2-2.3A8.38,8.38,0,0,1,178,399.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.58 354.79 251.37 354.79 248.61 365.39 198.86 365.39 204.58 354.79",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18,207.88V352.15a7.29,7.29,0,0,0,7.29,7.3H332.14a7.29,7.29,0,0,0,7.29-7.3V207.88a7.29,7.29,0,0,0-7.3-7.3H132.49a7.3,7.3,0,0,0-4.44,1.51,5.27,5.27,0,0,0-.51.43,6.85,6.85,0,0,0-1.26,1.53,6.32,6.32,0,0,0-.6,1.19A7.46,7.46,0,0,0,125.18,207.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.43,336.55v15.6a7.3,7.3,0,0,1-7.3,7.3H132.49a7.3,7.3,0,0,1-7.3-7.3v-15.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.43,336.55v15.6a7.3,7.3,0,0,1-7.3,7.3H132.49a7.3,7.3,0,0,1-7.3-7.3v-15.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.62,332.14H332a4,4,0,0,0,4-4V209a4,4,0,0,0-4-4H132.62a4,4,0,0,0-4,4V328.18A4,4,0,0,0,132.62,332.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07,200.58h4.42a7.3,7.3,0,0,0-7.3,7.3V352.15a7.3,7.3,0,0,0,7.3,7.3h-4.42a7.3,7.3,0,0,1-7.3-7.3V207.88A7.3,7.3,0,0,1,128.07,200.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.07,200.58h4.42a7.3,7.3,0,0,0-7.3,7.3V352.15a7.3,7.3,0,0,0,7.3,7.3h-4.42a7.3,7.3,0,0,1-7.3-7.3V207.88A7.3,7.3,0,0,1,128.07,200.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.18,280.92c-5.14-1-13.28,2.33-14.8,7.33a8,8,0,0,0-3.85-7.76c-2.65-1.53-6.12-2.61-8.56-.77a27.18,27.18,0,0,0-9.06-27.11c-7.82-6.33-19.23-7-28.26-2.59a19.37,19.37,0,0,0-11.34-27.41,82.5,82.5,0,0,0-39.15-3.71c-7.61,1.12-15.37,3.5-20.9,8.84s-7,15-3.28,21.73a24.69,24.69,0,0,0-24.9,5.89,24.38,24.38,0,0,0-5.43,24.83,8.23,8.23,0,0,0-7.85-.3,8,8,0,0,0-4.35,6.43,16.53,16.53,0,0,0-27,.92v44.9H336Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.16,
    y: 261.21,
    width: 126.62,
    height: 19.7,
    rx: 9.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,274.83a5.82,5.82,0,1,1,5.82-5.82A5.83,5.83,0,0,1,183.4,274.83Zm0-8.64a2.82,2.82,0,1,0,2.82,2.82A2.83,2.83,0,0,0,183.4,266.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.32,
    y: 270.7,
    width: 3,
    height: 9.75,
    transform: "translate(-139.23 214.72) rotate(-44.96)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "268.47 204.99 276.13 204.99 292.04 332.14 284.37 332.14 268.47 204.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.79 332.14 283.89 204.99 312.7 204.99 328.6 332.14 299.79 332.14",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,402.7l-.18,2.11a1.87,1.87,0,0,0,1.89,2.08h68.23a2.21,2.21,0,0,0,2.16-2l.19-2.21a1.78,1.78,0,0,0-1.81-2H243.86a3.16,3.16,0,0,1-.76-.09h-47A2.32,2.32,0,0,0,193.87,402.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,400.62H243.1a3.34,3.34,0,0,1-2.66-3.58H182Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.27,249.39l1.38-3.07a10.37,10.37,0,0,0,5.81,1.84c2.41,0,3.39-.81,3.39-1.89,0-3.29-10.23-1-10.23-7.56,0-3,2.41-5.48,7.41-5.48a11.79,11.79,0,0,1,6.11,1.56l-1.26,3.09A9.9,9.9,0,0,0,220,236.5c-2.41,0-3.34.9-3.34,2,0,3.24,10.23,1,10.23,7.46,0,2.94-2.44,5.46-7.47,5.46A12.51,12.51,0,0,1,212.27,249.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.31,247.86v3.26H229.69V233.53H243v3.27h-9.25v3.82h8.17v3.17h-8.17v4.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.4,242.33c0-5.23,4.07-9.1,9.62-9.1s9.63,3.85,9.63,9.1-4.1,9.1-9.63,9.1S245.4,247.56,245.4,242.33Zm15.13,0A5.51,5.51,0,1,0,255,248,5.37,5.37,0,0,0,260.53,242.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.17,
    y: 293.84,
    width: 49.9,
    height: 16.62,
    rx: 3.85,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.37,
    y: 293.84,
    width: 49.9,
    height: 16.62,
    rx: 3.85,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.92,210.66l24.79-44a1,1,0,0,1,1.74,0l24.79,44a1,1,0,0,1-.87,1.48H210.8A1,1,0,0,1,209.92,210.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.92,210.66l24.79-44a1,1,0,0,1,1.74,0l24.79,44a1,1,0,0,1-.87,1.48H210.8A1,1,0,0,1,209.92,210.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.8,218.73l-1.21-4.94h-4.34l-1.2,4.94A8.82,8.82,0,0,0,223.8,218.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.25,213.79l-.28,1.15a8.69,8.69,0,0,0,4.9,0l-.28-1.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.67,216.18c-.08.32-.16.63-.23.93a10,10,0,0,0,6,0l-.22-.93A14,14,0,0,1,217.67,216.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,213.44a12,12,0,0,1-9.16,0v-36.7a15.59,15.59,0,0,1,4.58-11.06A15.59,15.59,0,0,1,225,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v34.59a13.9,13.9,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v34.59a13.9,13.9,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v26a16.67,16.67,0,0,0,9.16,0v-26a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v26a16.67,16.67,0,0,0,9.16,0v-26a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v13.6a16.58,16.58,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v13.6a16.58,16.58,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v1.59a16.67,16.67,0,0,0,9.16,0v-1.59a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,176.74v1.59a16.67,16.67,0,0,0,9.16,0v-1.59a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,215.84,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.27,218.73l-1.2-4.94h-4.34l-1.21,4.94A8.82,8.82,0,0,0,253.27,218.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.73,213.79l-.28,1.15a8.69,8.69,0,0,0,4.9,0l-.28-1.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.14,216.18c-.07.32-.15.63-.22.93a10,10,0,0,0,6,0l-.23-.93A14,14,0,0,1,247.14,216.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.48,213.44a12,12,0,0,1-9.16,0v-36.7a15.59,15.59,0,0,1,4.58-11.06,15.59,15.59,0,0,1,4.58,11.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v34.59a13.9,13.9,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v34.59a13.9,13.9,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v26a16.67,16.67,0,0,0,9.16,0v-26a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v26a16.67,16.67,0,0,0,9.16,0v-26a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v13.6a16.58,16.58,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v13.6a16.58,16.58,0,0,0,9.16,0V176.74a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v1.59a16.67,16.67,0,0,0,9.16,0v-1.59a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,176.74v1.59a16.67,16.67,0,0,0,9.16,0v-1.59a15.59,15.59,0,0,0-4.58-11.06A15.59,15.59,0,0,0,245.32,176.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.61,221.56l-2-8h-7l-1.95,8A14.15,14.15,0,0,0,240.61,221.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.66,213.59s-.29,1.2-.46,1.86a14.13,14.13,0,0,0,7.92,0l-.46-1.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71,217.46l-.36,1.5a16.26,16.26,0,0,0,9.62,0l-.36-1.5A23,23,0,0,1,230.71,217.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,213a19.22,19.22,0,0,1-14.8,0V153.78a25.17,25.17,0,0,1,7.4-17.85,25.17,25.17,0,0,1,7.4,17.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v55.85a22.61,22.61,0,0,0,14.8,0V153.78a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v55.85a22.61,22.61,0,0,0,14.8,0V153.78a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v41.94a27,27,0,0,0,14.8,0V153.78a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v41.94a27,27,0,0,0,14.8,0V153.78a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v22a27,27,0,0,0,14.8,0v-22a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v22a27,27,0,0,0,14.8,0v-22a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v2.57a27,27,0,0,0,14.8,0v-2.57a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.78v2.57a27,27,0,0,0,14.8,0v-2.57a25.17,25.17,0,0,0-7.4-17.85A25.17,25.17,0,0,0,227.76,153.78Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.47,165.63a4.31,4.31,0,1,1-4.31-4.3A4.31,4.31,0,0,1,239.47,165.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.16,169.94a4.29,4.29,0,0,1-4.29-4c0,.11,0,.22,0,.32a4.31,4.31,0,0,0,8.62,0c0-.1,0-.21,0-.32A4.3,4.3,0,0,1,235.16,169.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.16,169.94a4.29,4.29,0,0,1-4.29-4c0,.11,0,.22,0,.32a4.31,4.31,0,0,0,8.62,0c0-.1,0-.21,0-.32A4.3,4.3,0,0,1,235.16,169.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.16,
    cy: 165.63,
    r: 3.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,168.66l1.25-5.86a2.88,2.88,0,0,0-1-.2L234,168.45A2.85,2.85,0,0,0,235,168.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,168.51l1.08-5.11a3,3,0,0,0-.45-.34l-1.19,5.58A3.5,3.5,0,0,0,236.14,168.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235,168.66l1.25-5.86a2.88,2.88,0,0,0-1-.2L234,168.45A2.85,2.85,0,0,0,235,168.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,168.51l1.08-5.11a3,3,0,0,0-.45-.34l-1.19,5.58A3.5,3.5,0,0,0,236.14,168.51Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.57,281.26l-1.15.25a2.52,2.52,0,0,0-2,2.14l-.1.81a2.5,2.5,0,0,0,.82,2.19c1.89,1.65,6.35,4.71,11.75,2.74l4.31-3.25-.71-5.82-9-1.3a2.51,2.51,0,0,0-1.49.56Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.23 286.14 371.2 285.54 369.35 279.03 358.52 280.32 359.23 286.14",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.36,279.08a4.66,4.66,0,0,0-.48,3,9.19,9.19,0,0,0,1.93,4.54h0a13.28,13.28,0,0,0-5.8,1.43l-.1.05c-6.24-4.26-2.64-9.31-2.64-9.31l.41.06A32.46,32.46,0,0,0,366.36,279.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,284.45c-11.12,2.56-24.95,2.31-24.95,2.31a4.32,4.32,0,0,1-.59-2.55c.1-1.86.35-4.19,1-5.13s5.46-1.44,5.46-1.44,9.29-4.31,11.05-5.72,1.69-8,1.36-12.33c-1.77-23.27,2.32-25,6-26.07C398,231.35,400.71,282.18,390.87,284.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.68,289.44h31.08c1,0,1.47-.82,1-1.83L339,270.08a3.22,3.22,0,0,0-2.65-1.83H305.26c-1,0-1.47.82-1,1.83l7.8,17.53A3.21,3.21,0,0,0,314.68,289.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.68,289.44h31.08c1,0,1.47-.82,1-1.83L339,270.08a3.22,3.22,0,0,0-2.65-1.83H305.26c-1,0-1.47.82-1,1.83l7.8,17.53A3.21,3.21,0,0,0,314.68,289.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.91,268.25h1.35c-1,0-1.47.82-1,1.83l7.8,17.53a3.21,3.21,0,0,0,2.64,1.83h-1.34a3.22,3.22,0,0,1-2.65-1.83l-7.79-17.53C302.45,269.07,302.9,268.25,303.91,268.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.91,268.25h1.35c-1,0-1.47.82-1,1.83l7.8,17.53a3.21,3.21,0,0,0,2.64,1.83h-1.34a3.22,3.22,0,0,1-2.65-1.83l-7.79-17.53C302.45,269.07,302.9,268.25,303.91,268.25Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.26 287.43 343.39 287.43 335.76 270.26 307.63 270.26 315.26 287.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.26 287.43 343.39 287.43 335.76 270.26 307.63 270.26 315.26 287.43",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.82,288.07s.77,10.26.88,13.86c.75,24.05-18.88,25.88-33.32,23.23l-52.3-14.62c-2.07,6.95-26.25,45.22-26.25,45.22l-12.71-7.3s13.18-31.59,21.69-53.58c4.85-12.55,44.38-3.87,58.94-1.28,4.42,1.19,3.57-5.72,3.57-5.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.59 355.04 288.73 363.13 279.68 358.63 284.39 349.42 293.59 355.04",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,357c-1.19-.55-2.33-1.33-2.49-2a1,1,0,0,1,.47-1,1.31,1.31,0,0,1,1-.2c1.81.29,4.29,3.74,4.39,3.89a.24.24,0,0,1,0,.29.28.28,0,0,1-.27.1A18.61,18.61,0,0,1,274.86,357Zm-.67-2.57a1.53,1.53,0,0,0-.46-.14.69.69,0,0,0-.59.11c-.3.21-.31.37-.28.48.16.83,2.58,1.95,4.47,2.55A11.5,11.5,0,0,0,274.19,354.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,358a.12.12,0,0,1-.09,0c-.91-1-2.27-4.17-1.57-5.16.14-.25.48-.48,1.14-.25a1.88,1.88,0,0,1,1.09,1c.76,1.57-.17,4.28-.21,4.4a.24.24,0,0,1-.2.16A.25.25,0,0,1,277.89,358Zm-.57-5-.12-.07c-.43-.16-.53,0-.57.05-.36.62.41,2.94,1.28,4.19a5.9,5.9,0,0,0,.07-3.53,1.29,1.29,0,0,0-.66-.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.52,357.15,290,361.94a.93.93,0,0,1,.53,1l-2,9.4a1.54,1.54,0,0,1-1.83,1.2,1.24,1.24,0,0,1-.31-.1c-3.75-1.79-7-3.54-11.73-5.68-5.55-2.54-4.45-1.23-11-4.13-4-1.75-2.63-6.55-.87-6,8.08,2.54,9.93.59,14.13-.79A3.61,3.61,0,0,1,279.52,357.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.12 359.15 293.59 355.04 284.39 349.42 282.11 353.87 291.12 359.15",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.85,355l-15.76-9.83a4,4,0,0,0-2,4.13L296.25,359S298.28,358.87,298.85,355Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.41 395.29 318.5 404.26 308.76 402.98 310.18 393.02 320.41 395.29",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.81,403c-1.27-.13-2.56-.49-2.93-1.08a.91.91,0,0,1,.12-1,1.28,1.28,0,0,1,.82-.49c1.75-.3,5.12,2.08,5.27,2.19a.24.24,0,0,1,.09.26.26.26,0,0,1-.22.18A18.41,18.41,0,0,1,303.81,403Zm-1.43-2.15a1.48,1.48,0,0,0-.47,0,.69.69,0,0,0-.51.29c-.21.29-.16.44-.1.53.41.71,3,1,4.91.93A11.23,11.23,0,0,0,302.38,400.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.93,403a.16.16,0,0,1-.1,0c-1.17-.67-3.41-3.12-3.08-4.25.05-.28.29-.59,1-.59a1.77,1.77,0,0,1,1.3.54c1.2,1.2,1.2,4,1.2,4.11a.23.23,0,0,1-.13.21A.18.18,0,0,1,306.93,403Zm-2.1-4.38-.13,0c-.44,0-.49.17-.51.23-.13.69,1.31,2.58,2.5,3.45a5.68,5.68,0,0,0-1.05-3.26,1.3,1.3,0,0,0-.81-.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.15,401.66l11.15,1.1a.9.9,0,0,1,.81.79l1.13,9.27a1.51,1.51,0,0,1-1.3,1.68,1.69,1.69,0,0,1-.32,0c-4-.47-7.57-1-12.57-1.52-5.91-.58-4.48.27-11.44-.31-4.19-.36-4.49-5.19-2.69-5.25,8.22-.22,9.31-2.59,12.72-5.19A3.65,3.65,0,0,1,308.15,401.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.43 398.26 319.61 399.05 320.41 395.29 310.18 393.02 309.43 398.26",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.3 391.74 323.01 392.87 308.08 391.69 308.24 390.56 323.3 391.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.91,396.42l-3.68-.33-10.36-.93-3.34-.3a3.91,3.91,0,0,1-.15-4.45l1.86.15,15.06,1.18,1.08.09C325.63,395.42,323.91,396.42,323.91,396.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.53,334.08c-13.51,1.19-44.67,1.69-48.89,1.07L323.3,391.74l-15.06-1.18s1.59-48.93,8.23-69.16c5.34-16.26,90.76-12.89,90.76-12.89l.3,4.58C408.12,328.87,400,332.71,384.53,334.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.53,334.08c-13.51,1.19-44.67,1.69-48.89,1.07L323.3,391.74l-15.06-1.18s1.59-48.93,8.23-69.16c5.34-16.26,90.76-12.89,90.76-12.89l.3,4.58C408.12,328.87,400,332.71,384.53,334.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.23,327.31a2.32,2.32,0,0,1,0-.27l0,.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.24,320l-.15,1.11A9.82,9.82,0,0,1,317.24,320Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.06 231.59 369.21 237.65 378.54 229.67 372.71 222.51 365.06 231.59",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.14,234.46c1.8-2.65,1-6.76,1-6.76l-1.64,2.09-1.42,1.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.1,218.24c.2.59.68,1,1.07.82s.56-.77.35-1.34-.67-1-1.07-.81S348.91,217.65,349.1,218.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,218.42l-1.32,5.66a4.4,4.4,0,0,0,3.8-1Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.51,214.11a.34.34,0,0,1,.31,0,2.58,2.58,0,0,0,2.35-.18.31.31,0,0,1,.45.07.34.34,0,0,1-.08.46,3.15,3.15,0,0,1-3,.27.33.33,0,0,1-.19-.43h0A.44.44,0,0,1,348.51,214.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.27,208c3,7.73,4.49,10.94,2.43,16.65-4.05,6.75-13.38,10.85-18.7,4.23-4.78-6-8.93-17.57-2.87-24.2a11.53,11.53,0,0,1,16.21-1A11,11,0,0,1,371.27,208Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.59,210.3a62.31,62.31,0,0,0-.77,7.84,12.2,12.2,0,0,1-7.93,11.07h0s-10.9-.13-15.53-13.84a7.84,7.84,0,0,1-8.24-10.08c.89-2.92,4.58-4.74,7.63-4.85a10,10,0,0,1,8.56-3.88,20.65,20.65,0,0,1,9.29,3.08,15.7,15.7,0,0,1,6.2,5.58A8,8,0,0,1,378.59,210.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,217a6.39,6.39,0,0,0-.12,4.93c.84,2.09,3.08,1.74,4.37,0,1.17-1.59,2.12-4.57.54-6.11S357.5,215.1,356.63,217Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.62,225.16c-3,.13-7.43,2.16-13.35,6.24a2.41,2.41,0,0,0-.8,2.2c.07.8.87,1.55,1.63,1.3.39,1,.65,2.1,1,3.06a41.37,41.37,0,0,1,5.74-2.4,77,77,0,0,1,9.15-3c-.83-1.27-1.94-2.51-2.27-4a1.64,1.64,0,0,0,.93-1.88A2.48,2.48,0,0,0,378.62,225.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.62,225.16c-3,.13-7.43,2.16-13.35,6.24a2.41,2.41,0,0,0-.8,2.2c.07.8.87,1.55,1.63,1.3.39,1,.65,2.1,1,3.06a41.37,41.37,0,0,1,5.74-2.4,77,77,0,0,1,9.15-3c-.83-1.27-1.94-2.51-2.27-4a1.64,1.64,0,0,0,.93-1.88A2.48,2.48,0,0,0,378.62,225.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,301.76a399,399,0,0,1-16.17-46.61c-4.64-17.32,8.61-17.62,24.6-21.92,12.68-3.41,18.1-.36,21.72,6.07s9.46,60.85,9.46,60.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,301.76a399,399,0,0,1-16.17-46.61c-4.64-17.32,8.61-17.62,24.6-21.92,12.68-3.41,18.1-.36,21.72,6.07s9.46,60.85,9.46,60.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,301.76a399,399,0,0,1-16.17-46.61c-4.64-17.32,8.61-17.62,24.6-21.92,12.68-3.41,18.1-.36,21.72,6.07s9.46,60.85,9.46,60.85Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,276.8l-1.12,0a2.41,2.41,0,0,0-2.21,1.7l-.23.74a2.38,2.38,0,0,0,.4,2.2c1.51,1.87,5.19,5.49,10.6,4.53l4.61-2.34.3-5.6-8.22-2.71a2.43,2.43,0,0,0-1.5.28Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.07 283.67 335.43 285.1 334.77 278.66 324.37 278.07 324.07 283.67",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,278.21a4.52,4.52,0,0,0-1,2.78,8.86,8.86,0,0,0,1.06,4.6h0a12.65,12.65,0,0,0-5.7.38l-.1,0c-5.16-5.05-.93-9.2-.93-9.2l.38.12A31,31,0,0,0,332,278.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.12,287.34c-10.89.56-23.86-2-23.86-2a4.15,4.15,0,0,1-.14-2.5c.41-1.74,1-3.89,1.83-4.66s5.38-.44,5.38-.44,9.46-2.52,11.35-3.55S351.6,267,352,262.84c2.21-22.2,6.35-23.16,10-23.53C369.65,238.55,363.76,286.85,354.12,287.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,413.8l-7.55-63.1a12.7,12.7,0,0,0-12.61-11.19H344.93a12.65,12.65,0,0,0-12.54,10.67L322.23,413l-2-.32,10.17-62.8a14.64,14.64,0,0,1,14.51-12.35h24.95a14.72,14.72,0,0,1,14.6,12.95l7.55,63.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.94,413.8l-7.55-63.1a12.7,12.7,0,0,0-12.61-11.19H379.83a12.64,12.64,0,0,0-12.54,10.67L357.12,413l-2-.32,10.17-62.8a14.63,14.63,0,0,1,14.51-12.35h24.95a14.72,14.72,0,0,1,14.6,12.95l7.55,63.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.91,
    y: 395.42,
    width: 34.35,
    height: 2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.49,
    y: 349.58,
    width: 35.51,
    height: 2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,339.94h26.13a19.31,19.31,0,0,0,19.25-17.79l3.72-46.94a13.09,13.09,0,0,0-13-14.12H411.6a38.1,38.1,0,0,0-36.51,27.21l-10,33.51a13.25,13.25,0,0,1-12.71,9.47H334.1a8.66,8.66,0,0,0-8.65,8.66H390Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,339.94h26.13a19.31,19.31,0,0,0,19.25-17.79l3.72-46.94a13.09,13.09,0,0,0-13-14.12H411.6a38.1,38.1,0,0,0-36.51,27.21l-10,33.51a13.25,13.25,0,0,1-12.71,9.47H334.1a8.66,8.66,0,0,0-8.65,8.66H390Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speedometer--inject-116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.09,177.94h0v-.11A.41.41,0,0,1,364.09,177.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,165.28a25.78,25.78,0,0,0-7.25,11.64l-1.83,0A30.33,30.33,0,0,1,313.39,163Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,165.28a25.78,25.78,0,0,0-7.25,11.64l-1.83,0A30.33,30.33,0,0,1,313.39,163Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6,159.29a25.84,25.84,0,0,0-10.6,6L313.39,163a32.17,32.17,0,0,1,11.32-9.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6,159.29a25.84,25.84,0,0,0-10.6,6L313.39,163a32.17,32.17,0,0,1,11.32-9.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.83,149.8l-.89,8.93a22.21,22.21,0,0,0-3.87-.33,24.11,24.11,0,0,0-6.47.89l-2.89-6.1a29.68,29.68,0,0,1,13.7-3.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.83,149.8l-.89,8.93a22.21,22.21,0,0,0-3.87-.33,24.11,24.11,0,0,0-6.47.89l-2.89-6.1a29.68,29.68,0,0,1,13.7-3.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.21,153.59l-5.83,8.55a21,21,0,0,0-8.44-3.41l.89-8.93A26.17,26.17,0,0,1,352.21,153.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.21,153.59l-5.83,8.55a21,21,0,0,0-8.44-3.41l.89-8.93A26.17,26.17,0,0,1,352.21,153.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,163.67l-9.1,4.87a20.43,20.43,0,0,0-6-6.4l5.83-8.55A25,25,0,0,1,361.46,163.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,163.67l-9.1,4.87a20.43,20.43,0,0,0-6-6.4l5.83-8.55A25,25,0,0,1,361.46,163.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.12,177.57l-8.9-.1a21.31,21.31,0,0,0-2.86-8.93l9.1-4.87A26.43,26.43,0,0,1,364.12,177.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.12,177.57l-8.9-.1a21.31,21.31,0,0,0-2.86-8.93l9.1-4.87A26.43,26.43,0,0,1,364.12,177.57Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.1,177.83a.41.41,0,0,1,0,.11,33.6,33.6,0,0,1-2.37,9.1l-7.21-1.63.58-2.75c.05-.36.1-.72.13-1.08h0l0-.22h0a21.94,21.94,0,0,0,0-3.89l8.9.1c0,.06,0,.1,0,.15A.37.37,0,0,1,364.1,177.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,186.47l-.53.12c-.17-.69-.31-1.39-.43-2.1a27.87,27.87,0,0,1-.24-6.55h0v-.11a.45.45,0,0,1,0-.11c0-.27.05-.55.09-.82l1.83,0a24.21,24.21,0,0,0-.86,4.44s0,.07,0,.11,0,.07,0,.11a23.88,23.88,0,0,0-.05,2.67C308.85,185,308.91,185.74,309,186.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,186.47l-.53.12c-.17-.69-.31-1.39-.43-2.1a27.87,27.87,0,0,1-.24-6.55h0v-.11a.45.45,0,0,1,0-.11c0-.27.05-.55.09-.82l1.83,0a24.21,24.21,0,0,0-.86,4.44s0,.07,0,.11,0,.07,0,.11a23.88,23.88,0,0,0-.05,2.67C308.85,185,308.91,185.74,309,186.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,185l-.76,1.88-1.54-.34-14.35-3.25-6.18-1.4a8.25,8.25,0,0,0,1.06-1.81,7.52,7.52,0,0,0,.56-2.37l13.7,4.71h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,177.73a7.72,7.72,0,0,1-1.62,4.18l-5.55-1.26,1.75-4.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,177.73a7.72,7.72,0,0,1-1.62,4.18,8,8,0,0,1-2.54,2.13c-3.57,1.91-7.78.71-9.39-2.7a7.52,7.52,0,0,1,3.54-9.63c3.57-1.91,7.78-.7,9.4,2.7A6.64,6.64,0,0,1,342.31,177.73Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Number--inject-116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.48,173.5h5.73v4.8h-6.3l-.88,7h-5l.88-7h-6.47l-.88,7H96.66l.88-7H91.77v-4.8h6.34l.92-7.13H93.27v-4.8h6.34l.88-7h4.93l-.88,7H111l.88-7h4.93l-.88,7h5.72l0,4.8h-6.34Zm-5,0,.92-7.13H104L103,173.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,154.52v30.82h-7.13V160.25h-6.16v-5.73Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-116"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.15,
    y: 282.69,
    width: 49.31,
    height: 33.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.15,
    y: 282.69,
    width: 49.31,
    height: 3.11,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.18,301.47l8.07,4.47a2.66,2.66,0,0,1,.8.6,1.08,1.08,0,0,1,.2.68,1.26,1.26,0,0,1-.37.91,1.2,1.2,0,0,1-.88.38,2.36,2.36,0,0,1-1-.36l-10.4-5.79a1,1,0,0,1,0-1.78L76,294.79a2.47,2.47,0,0,1,1-.35,1.28,1.28,0,0,1,1.26,1.27,1,1,0,0,1-.2.68,2.5,2.5,0,0,1-.8.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,293.14l-8,17.19a2.35,2.35,0,0,1-.55.84,1.17,1.17,0,0,1-.76.26,1.23,1.23,0,0,1-.88-.37,1.11,1.11,0,0,1-.37-.82,2.64,2.64,0,0,1,.29-1l8-17.18a2.5,2.5,0,0,1,.54-.84,1.24,1.24,0,0,1,1.63.1,1.1,1.1,0,0,1,.37.82A2.64,2.64,0,0,1,89.93,293.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,301.47,91.9,297a2.45,2.45,0,0,1-.81-.61,1.1,1.1,0,0,1-.2-.68,1.19,1.19,0,0,1,.38-.89,1.2,1.2,0,0,1,.88-.38,2.42,2.42,0,0,1,1,.35l10.4,5.79a1,1,0,0,1,0,1.78l-10.4,5.79a2.33,2.33,0,0,1-1,.36,1.23,1.23,0,0,1-.89-.38,1.3,1.3,0,0,1-.37-.91,1.14,1.14,0,0,1,.2-.68,2.61,2.61,0,0,1,.81-.6Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.3b570e036e64cce4ec3eb6c415faba6b.svg";
export { ForwardRef as ReactComponent };